var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 11.25V14.375H21.4375C20.6875 18.75 17.1875 21.875 12.8125 21.875C7.6875 21.875 3.4375 17.625 3.4375 12.5C3.4375 7.375 7.6875 3.125 12.8125 3.125C15.4375 3.125 17.6875 4.25 19.3125 6L21.5625 3.75C19.3125 1.5 16.3125 0 12.8125 0C5.9375 0 0.3125 5.625 0.3125 12.5C0.3125 19.375 5.9375 25 12.8125 25C19.6875 25 24.6875 19.375 24.6875 12.5V11.25H14.0625Z",
    fill: "#FF82AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogl);
export default __webpack_public_path__ + "static/media/googl.cd160512d246d4fe4d0d074fa3d77083.svg";
export { ForwardRef as ReactComponent };